import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import {withRouter} from "react-router-dom";
import LoadingSpinner from '../loadingSpinner/';
import Line from './line';
import Message from '../message';
import LineMessage from '../lineMessage/';

// const getLeagueKeys = memoizee((league) => _.keysIn(league));

const Error = ({text}) => (
	<div dangerouslySetInnerHTML={{ __html: text}}></div>
)

@withRouter
@inject('lineStore', 'accountStore')
@observer
class LineContainer extends Component {

	componentDidMount(){
		// this.props.lineStore.route.setUrl(this.props.match.params);
		// console.log(this.props.match);
	}

  handlerClose = () => {
  	this.props.lineStore.line.clearResult();
  }

  componentDidUpdate(){
  	// this.props.lineStore.route.getUrl2(this.props.match.params);
		// console.log(this.props.match);
	}

	lineContainer = React.createRef();

	render() {

		if (!this.props.lineStore.line.mode) return false;

		const {isLoading, result, lineMessage} = this.props.lineStore.line;
		const {basketPosition} = this.props.accountStore.accountSettings;
		const {shortMenu} = this.props.lineStore;
		const wssData = this.props.lineStore.matchesList.getData();

		return (
			<div ref={this.lineContainer} className={`line-central-column l-c-c-c-s ${ basketPosition == 'right' ? 'line-central-column-short-right' : ''} ${shortMenu && basketPosition == 'right' ? 'line-central-column-short-left' : ''}`} id="line-central-column" >
				{isLoading ?
				<div>
					<LoadingSpinner />
				</div> : result.status && !wssData ?
						<Message text={result.text} type={result.type} onClose={this.handlerClose}/> :
						lineMessage.title && lineMessage.text ? <LineMessage title= {lineMessage.title} text={lineMessage.text}/>: <Line />
				}
		  </div>
		)
	}
}

export default LineContainer;



// WEBPACK FOOTER //
// ./src/components/line/index.js